@if (visible()) {
  <div class="aviso-push" [class.aviso-push--inset]="inset()" role="status">
    <div class="aviso-push__texto">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span>Activá las notificaciones para recibir avisos en este celular.</span>
    </div>
    <p-button label="Activar" severity="warn" size="small" [loading]="activando()" (onClick)="activar()" />
  </div>
}
